module.exports = __webpack_public_path__ + "static/media/coming-soon-icon.fef2f815.svg";